import * as React from "react";
import Component from "../../AbstractComponent";
import Logger from "../../../Logger/Logger";

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';

export default class SelectWrapper extends Component {
  constructor(public props) {
    super(props);
	}

	public componentDidMount = () => {
		this.checkMandatoryProps();
	}
	
	public checkMandatoryProps = () => {
		if (typeof this.props.error === "undefined") {
      Logger.logError(new Error(`${location?.pathname}, <Select> checkMandatoryProps(error): ${this.props.label}`), "warning");
		}
	}

  public render() {		
    return (
      <FormControl
				className={`${this.props.className} select-filled-styles`}
				error={!!this.props.error}
				style={this.props.style}
				disabled={this.props.disabled}
				// variant={this.props.variant}
				variant={"filled"}
			>
				<InputLabel
					htmlFor={this.props.htmlFor}
				>
					{this.props.label}
				</InputLabel>
				<Select
					value={this.props.value}
					onChange={this.props.onChange}
					name={this.props.name} 
					id={this.props.id}
				>
					{this.props.children}
				</Select>
				{!!this.props.error && <FormHelperText error={true}>{this.props.error}</FormHelperText>}
			</FormControl>
    );
  }
}
